import inviteAdminOnboarding from './admin_onboarding_invite_selector'
import getStartedAdminOnboarding from './admin_onboarding_start_trial_selector'
import schoolAdminOnboarding from './admin_onboarding_school_selector'
import stepAdminOnboarding from './admin_onboarding_step_selector'
import metricAdminOnboarding from './admin_onboarding_metric_selector'
import baseAdminOnboarding from './admin_onboarding_base_selector'
import getAdminOnboardingShowLastStep from './admin_onboarding_show_last_step_selector'
import getAdminOnboardingIsAdmin from './admin_onboarding_is_admin_selector'
import getAdminOnboardingDurationDays from './admin_onboarding_get_duration_days'
import getAdminOnboardingIsTrialFromSF from './admin_onboarding_is_trial_from_sf_selector'

export default {
	inviteAdminOnboarding,
	getStartedAdminOnboarding,
	schoolAdminOnboarding,
	stepAdminOnboarding,
	metricAdminOnboarding,
	baseAdminOnboarding,
	getAdminOnboardingShowLastStep,
	getAdminOnboardingIsAdmin,
	getAdminOnboardingDurationDays,
	getAdminOnboardingIsTrialFromSF,
}
